import _ from 'lodash';
import store from '$$globalStore';
import helpers from './helpers';
import constants from '$$helpers/constants';

export default {
  fromStore(tasksToUpdate, ganttInstance, sourceEvent) {
    const parentsToRefresh = [];
    let needClearAndParse = false;
    let needAutoschedule = false;

    ganttInstance.batchUpdate(() => {
      tasksToUpdate.forEach(task => {
        if (!ganttInstance.isTaskExists(task.id)) {
          return;
        }

        const ganttTask = ganttInstance.getTask(task.id);
        const updatedTask = { ...ganttTask, ...task };

        if (ganttTask.sortorder !== updatedTask.sortorder && ganttInstance.config.gantt_id) {
          needClearAndParse = true;
        }

        if (ganttTask.parent !== updatedTask.parent) {
          ganttTask.parent && parentsToRefresh.push(ganttTask.parent);
          updatedTask.parent && parentsToRefresh.push(updatedTask.parent);
        }

        if (ganttTask.type !== updatedTask.type) {
          parentsToRefresh.push(task.id);
        }

        // Preserve local expand state on cascade updates (e.g. parent dates from GanttWorker)
        // — only apply when the store payload explicitly carries open (expand/collapse toggle).
        if (Object.prototype.hasOwnProperty.call(task, 'open')) {
          updatedTask.$open = task.open ? 1 : 0;
          updatedTask.open = task.open;
        }

        if (ganttTask.parent === 1) { // for multiViews
          updatedTask.parent = 1;
        }

        const strToDate = ganttInstance.date.str_to_date(ganttInstance.config.date_format);

        if (_.isString(updatedTask.start_date)) {
          updatedTask.start_date = strToDate(updatedTask.start_date);
        }

        if (_.isString(updatedTask.end_date)) {
          updatedTask.end_date = strToDate(updatedTask.end_date);
        }

        if (updatedTask.deadline && _.isString(updatedTask.deadline)) {
          updatedTask.deadline = strToDate(updatedTask.deadline);
        }

        if (_.isString(updatedTask.estimation)) {
          updatedTask.estimation = parseFloat(updatedTask.estimation);
        }

        if (updatedTask.constraint_date) {
          updatedTask.constraint_date = null;
          updatedTask.constraint_type = null;
        }

        ganttInstance.silent(() => {
          ganttInstance.updateTask(task.id, updatedTask);
        });

        if (!needAutoschedule) {
          const connectedGroup = ganttInstance.getConnectedGroup(task.id);

          if (connectedGroup.links.length) {
            needAutoschedule = true;
          }
        }
      });
    });

    if (needClearAndParse) {
      helpers.clearAndParse(ganttInstance, true);
    } else if (parentsToRefresh.length) {
      helpers.updateButtonsInTasks(ganttInstance, parentsToRefresh);
    }

    if (needAutoschedule && ganttInstance.config.auto_scheduling.enabled) {
      ganttInstance.autoSchedule();
    }

    // if (sourceEvent?.type === constants.GANTT_SOURCE_EVENT_TYPES.PROJECT_CALENDAR_UPDATE) {
    //   if (ganttInstance.config.auto_scheduling.enabled) {
    //     ganttInstance.autoSchedule();
    //   }
    // }
  },

  fromGantt(tasksToUpdate, ganttInstance) {
    store.dispatch('tasksModel/updateTasks', {
      tasks: tasksToUpdate.map(item => item.data),
      // diff,
      // links: [],
      // fromGantt: true,
    });
  },
};
